import { render } from "./HelpCenterButton.vue?vue&type=template&id=15f4b33e"
import script from "./HelpCenterButton.vue?vue&type=script&lang=js"
export * from "./HelpCenterButton.vue?vue&type=script&lang=js"
script.render = render

export default script